import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Select from '../select';
import withTranslate from '../../hoc/with-translate';
import styles from './member-filter-field.scss';

const getOptions = (options, t) =>
  _.map(options, (translation, value) => ({
    value,
    label: t(translation),
  }));

const MembersFilterField = ({ value, filters, className, t, ...props }) => (
  <div className={styles.container}>
    {filters && Object.keys(filters).length > 1 ? (
      <div data-hook="am-filter-field" className={className}>
        <Select
          ariaLabel={t('members-page.members-filter.aria-label')}
          defaultValue={value}
          options={getOptions(filters, t)}
          isTransparent
          isScrollable={false}
          {...props}
        />
      </div>
    ) : null}
  </div>
);

MembersFilterField.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  filters: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func,
};

export default _.flowRight(withTranslate)(MembersFilterField);
